var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideomodalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.75 15L6.75 9C6.75 5.68629 9.43629 3 12.75 3C16.0637 3 18.75 5.68629 18.75 9V17C18.75 19.2091 16.9591 21 14.75 21C12.5409 21 10.75 19.2091 10.75 17V9C10.75 7.89543 11.6454 7 12.75 7C13.8546 7 14.75 7.89543 14.75 9V17",
    stroke: "#726C6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideomodalicon);
export default __webpack_public_path__ + "static/media/videomodalicon.3b1916b5ed9225292cf7a45418a7aae9.svg";
export { ForwardRef as ReactComponent };